import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import styles from './_progressLine.module.scss';

export default class ProgressLine extends Component {
  state = {
    isDetailBox: false,
  };

  openDetailBox = () => {
    this.setState({ isDetailBox: true });
  };

  closeDetailBox = () => {
    this.setState({ isDetailBox: false });
  };

  render() {
    const { progress = 0, startDate, endDate, progressRewardsData = [] } = this.props;
    const { isDetailBox } = this.state;
    const totalRewardsEarn = _.sumBy(progressRewardsData, (reward) => Number(reward.amount)) || 0;

    return (
      <div className={cx(styles['progress-bar-outer'])}>
        <div className={cx(styles['progress-bar'])} onClick={this.openDetailBox}>
          <div className={styles['active-progress-bar']} style={{ width: `${progress}%` }} />

          <div className={styles['description']}>
            <div className={cx(styles['desc-box'], styles['first-desc-box'])}>
              {startDate}
              <div className={styles['line']} />
            </div>
            <div className={styles['desc-box']}>
              &nbsp;
              <div className={styles['line']} />
            </div>
            <div className={cx(styles['desc-box'], styles['earn-reward'])}>
              earn your reward
              <div className={styles['line']} />
            </div>
            <div className={cx(styles['desc-box'], styles['earn-reward'])}>
              earn your reward
              <div className={styles['line']} />
            </div>
            <div className={cx(styles['desc-box'], styles['earn-reward'])}>
              earn your reward
              <div className={styles['line']} />
            </div>

            <div className={cx(styles['desc-box'], styles['last-desc-box'])}>{endDate}</div>
          </div>
        </div>

        <div
          className={cx(styles['detail-box'], {
            [styles['detail-box-open']]: isDetailBox,
          })}
        >
          <div className={styles['detail-header']}>
            <div className={styles['detail-title']}>
              {' '}
              Future Rewards <br />
              Rs. {totalRewardsEarn}
            </div>
            <div className={styles['detail-close']} onClick={this.closeDetailBox}>
              <img src="/images/cross.svg" alt="close" />
            </div>
          </div>
          <div className={styles['detail-list']}>
            {progressRewardsData &&
              progressRewardsData.length > 0 &&
              progressRewardsData.map((data, index) => {
                const reachingAmount = Math.round((100 / progressRewardsData.length) * (index + 1));
                return (
                  <div className={styles['list']} key={index}>
                    <span>Rs. {data?.amount}</span>
                    {index === 0 && ' for setting up the plan'}
                    {index !== 0 && ` for reaching ${reachingAmount}%`}
                  </div>
                  // <div className={styles['list']}>
                  //   <span>Rs. 300 </span> for reaching 25%
                  // </div>
                  // <div className={styles['list']}>
                  //   <span>Rs. 300</span> for for reaching 75%
                  // </div>
                  // <div className={styles['list']}>
                  //   <span>Rs. 300</span> for for reaching 100%
                  // </div>
                  // <div className={styles['list']}>
                  //   <span>Rs. 50</span> bonus if you make an additional buy between installments
                  // </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}
